import { render, staticRenderFns } from "./BaseBtnActionGroup.vue?vue&type=template&id=2c4939b4"
import script from "./BaseBtnActionGroup.vue?vue&type=script&lang=js"
export * from "./BaseBtnActionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports